import React from 'react';
interface LogoCarouselProps {
  logos?: string[];
}
export const LogoCarousel: React.FC<LogoCarouselProps> = ({
  logos = []
}) => {
  // Double the logos array to create seamless infinite scroll
  const doubledLogos = [...logos, ...logos];
  const getLogoHeight = (logoUrl: string) => {
    // Special handling for logos that need more vertical space
    if (logoUrl.includes('image_7.png') || logoUrl.includes('image_9.png')) {
      return 'h-20';
    }
    // Chiro Venture logo - wider aspect ratio
    if (logoUrl.includes('Chiro_Venture')) {
      return 'h-10';
    }
    // Ideal Response logo - square aspect ratio
    if (logoUrl.includes('favicon_update')) {
      return 'h-14';
    }
    return 'h-12';
  };
  const getLogoFilter = (logoUrl: string) => {
    // Chiro Venture logo is already white, don't invert
    if (logoUrl.includes('Chiro_Venture')) {
      return '';
    }
    // Ideal Response needs invert to look good on dark bg
    if (logoUrl.includes('favicon_update')) {
      return 'brightness-0 invert';
    }
    return 'brightness-0 invert';
  };
  return <div className="w-full overflow-hidden py-8" data-id="element-720">
      <div className="flex items-center gap-16 md:gap-32 animate-scroll-mobile md:animate-scroll-desktop" style={{
      width: 'max-content'
    }} data-id="element-721">
        {doubledLogos.map((logo, index) => <div key={index} className={`flex-shrink-0 w-auto opacity-70 hover:opacity-100 transition-opacity duration-300 filter ${getLogoFilter(logo)} ${getLogoHeight(logo)}`} data-id="element-722">
            <img src={logo} alt="Partner logo" className="h-full w-auto object-contain" data-id="element-723" />
          </div>)}
      </div>
    </div>;
};